/* eslint-disable jira/filename-case */
export const DEFAULT_OPTIONS = {
	preloadMaxAge: 2000,
	longerPreloadMaxAge: 10000,
	timeToIntent: 200,
};
